import { render, staticRenderFns } from "./white-list.vue?vue&type=template&id=0f33c992&scoped=true&"
import script from "./white-list.vue?vue&type=script&lang=js&"
export * from "./white-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f33c992",
  null
  
)

export default component.exports